/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { SalesTaxRateFinderDialogComponent } from './sales-tax-rate-finder-dialog.component';

export const salesTaxRateFinderDialogRoute = createDialogRoute({
  component: SalesTaxRateFinderDialogComponent,
});
